// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1cVID","range":"MonthRangeSwitch_range__y4Xqw","disabled":"MonthRangeSwitch_disabled__3OxI1"};